export default "__VITE_ASSET__BvPTM42___"